import QueueModalWrapper from "./QueueModalWrapper";
import {Button} from "@varymadellc/my-weed-club-component-library";
import FileInput from "../../../components/FileInput/FileInput";
import React, {useRef, useState} from "react";
import {useAuth} from "../../../providers/AuthProvider";
import {apiPost, extractPayloadFromResponse} from "../../../services/apiService";
import {useSiteMessage} from "../../../providers/SiteMessageProvider";
import setImageOnUpload from "../../../utils/setImageOnUpload";
import Loading from "../../../components/Loading/Loading";

export interface QueueModalVideoProps {
    setIsOpen: (value: string) => void;
    requestRefresh?: () => void;
}

const extensionIsSafe = (type: string) => {
    switch (type.toLowerCase().replace('.', '')) {
        case 'mpg':
        case 'mp4':
        case 'mpeg':
        case 'mov':
            return true;
        default:
            return false;
    }
}

export default function QueueModalVideo({setIsOpen, requestRefresh}: QueueModalVideoProps) {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const setIsOpenHandler = (value: string) => {
        if (!value) {
            setFile({image: '', name: ''});

            // setDescription('');

            setIsOpen(value || '');
        }
    }

    const {authToken} = useAuth();

    const {setMessage} = useSiteMessage();

    const [file, setFile] = useState<{image: string | ArrayBuffer | null; name: string;}>({image: '', name: ''});

    const fileRef = useRef<any>(null);

    const onSubmitHandler = (event: any) => {
        event.preventDefault();

        if (!fileRef?.current?.value) return;

        if (!extensionIsSafe(fileRef.current?.value.split('.').pop() || '')) {
            setMessage('File type is not a support video format');

            return;
        }

        async function postData() {
            try {
                setIsLoading(true);

                if (!file) return;

                const formData = new FormData();

                // @ts-ignore
                formData.append('file', file.image, file.name);

                const fileResponse = await apiPost('/upload?type=queue-file', formData, authToken, {'Content-Type': false});

                const {data: filePayload} = await extractPayloadFromResponse(fileResponse);

                const response = await apiPost('/q', JSON.stringify({
                    type: 'video',
                    metadata: {
                        src: filePayload.metadata.publicUrl,
                        // description,
                    }
                }), authToken);

                const {data: queueItem} = await extractPayloadFromResponse(response);

                if (queueItem) {
                    setMessage('Video added to Queue');

                    setIsOpen('');

                    requestRefresh && requestRefresh();
                }

                setIsLoading(false);
            } catch(error: any) {
                setIsLoading(false);

                const message = error.message;

                if (message.toLowerCase().includes('load failed')) {
                   setMessage('Try a small video file');

                   return;
                }

                setMessage(error.message);
            }
        }

        postData();
    };

    return (
        <QueueModalWrapper setIsOpen={setIsOpenHandler}>
            <>
                {isLoading && <Loading hasOverlay={true}/>}
                <div className="relative flex flex-col">
                    <h2>Add a Video</h2>
                    <hr className="mt-2"/>
                    <form onSubmit={onSubmitHandler} className="flex flex-col gap-4">
                        <label htmlFor="image">Select a Video</label>
                        <FileInput name="galleryImage"
                                   accept="video/*"
                                   type="file"
                                   _ref={fileRef}
                                   onChange={setImageOnUpload(setFile)}/>
                        {/*<label htmlFor="Description">Description</label>*/}
                        {/*<TextArea onChange={({target: {value}}: any) => setDescription(value)}/>*/}
                        <Button type="submit">Add</Button>
                    </form>
                    <br/>
                    <p>Please feel free to share your videos with us. If you&apos;re on a phone, you should be able to choose
                    to either select a video or take a live video.</p>
                    <p>We encourage you to be part of the virtual q. Share your cannabis and other content. Just keep it mainly
                    focused on cannabis. Wanna promote your brand? Do it. Got a new bong? Post it! What you smoking on today? Let us see!</p>
                </div>
            </>
        </QueueModalWrapper>
    );
}